export default "__VITE_ASSET__BhZXtdhZ__"